import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { ArrowLeftFromLine, ArrowRightFromLine, X, Lock, LockOpen, Play, Trash2, SquareChartGantt } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { useDispute } from "lib/units/dispute/hooks"
import { AddPreset, PresetsHandle, PresetTitlebar } from "."


export default function PresetsChooser({ 
  mode,
  selectFn, 
  autoExpand = true, 
  className="" 
}:{ 
  mode:string
  selectFn:any
  autoExpand?:boolean
  className?:string 
}){

  const { dspid }:any = useParams()
  const { store, AppStore }:any = appStore() 
  const { update } = AppStore 
  
  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { _id: dspid }, { enabled: !!dspid })
  const saveFn = queryTools.resource.save(["dispute"])

  const { addPreset, removePreset } = useDispute({saveFn})

  const [ expanded, setExpanded ] = useState(autoExpand)
  const [ presets, setPresets ] = useState<any>([])
  const [ newPreset, setNewPreset ] = useState<any>({ subdomain: "", rp: "" })

  if( !_Dispute || mode !== "preview" ) return <></>
  return (
    <div 
      className={cn(
        "fixed top-[10.75rem] right-1 z-30 w-8 h-[calc(100vh-11rem)] rounded-l p-[2px] *:text-gray-200",
        expanded === true && "w-[14rem] right-[0rem] bg-teal-900",
      )}
    >
        <PresetsHandle expanded={expanded} setExpanded={setExpanded} />
        { expanded === true && (
          <div className="w-full flex flex-col">
            <PresetTitlebar />
            
            <div className="w-full px-3 py-2">
              { _Dispute.settings.presets.length === 0 ? (
                <p className="text-sm font-normal">It's time to add your first preset. Enter the Representment Id and Subdomain below.</p>
              ):(
                <span className="block w-full text-sm font-normal text-xs leading-loose border-b border-solid border-b-white/50">
                  Choose from the options below.
                </span>
              )}

              <div className="w-full flex flex-col gap-[2px] py-2">

                <div className="grid grid-cols-12 gap-1 mb-3">
                  <div className="col-span-12 grid grid-cols-12 gap-1 py-[.25rem] mb-1 bg-teal-950/40">
                    <div className="col-span-3 text-xs uppercase px-1">RP</div>
                    <div className="col-span-8 text-xs uppercase px-1">Subdomain</div>
                    <div className="col-span-1"></div>
                  </div>

                  { _Dispute?.settings.presets.map( (preset:any) => (
                    <div 
                      key={preset.refstr} 
                      onClick={() => selectFn(preset, () => setExpanded(false))}
                      className="col-span-12 grid grid-cols-12 gap-[2px] py-[3px] hover:bg-teal-950/20 cursor-pointer"  
                    >
                      <div className="col-span-3 h-5 text-sm flex items-center justify-start pl-1">{ preset.rp }</div>
                      <div className="col-span-8 h-5 text-sm flex items-center px-1">{`${preset.subdomain.slice(0,22)}${preset.subdomain.length > 22 ? "..." : ""}` }</div>
                      <div className="col-span-1 h-5 pr-1 flex items-center ">
                        <Trash2 
                          onClick={(e:any) => {e.stopPropagation(); removePreset(_Dispute, preset.refstr)}} 
                          className="w-4 h-4 cursor-pointer" 
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <AddPreset dispute={_Dispute} addPresetFn={addPreset} />

              </div>
            </div>
          </div>
       )}
    </div>
  )
}